import { getLocaleLabel, readLocale, writeLocale } from "./locale";

export const navbar = {

    init() {
        // =========================
        // NAV ICON TOGGLE
        // =========================
        const navToggle = document.querySelector<HTMLElement>('[data-collapse-toggle="navbarMain"]');
        const iconOpen = document.getElementById('icon-open');
        const iconClose = document.getElementById('icon-close');

        if (navToggle) {
            const syncMobileMenuState = () => {
                const isExpanded = navToggle.getAttribute('aria-expanded') === 'true';

                iconOpen?.classList.toggle('hidden', isExpanded);
                iconClose?.classList.toggle('hidden', !isExpanded);
                document.body.classList.toggle('mobile-nav-open', isExpanded);
            };

            const observer = new MutationObserver(() => {
                syncMobileMenuState();
            });

            observer.observe(navToggle, { attributes: true });
            syncMobileMenuState();

        }

        // =========================
        // LOCALE LOGIC
        // =========================
        const current = readLocale();
        const currentLabel = getLocaleLabel(current);

        document.querySelectorAll<HTMLElement>(".locale-current").forEach(label => {
            label.textContent = currentLabel;
        });

        document.querySelectorAll<HTMLElement>(".locale-current-wrap").forEach(wrapper => {
            wrapper.classList.remove("locale-current-loading");
        });

        document.querySelectorAll<HTMLButtonElement>(".locale-option").forEach(btn => {

            const value = btn.dataset.currency;
            if (!value) return;

            btn.classList.toggle("active", value === current);

            btn.addEventListener("click", () => {

                const normalised = value === "NZ" ? "NZ" : "INT";

                writeLocale(normalised);

                location.reload();
            });

        });
    }
};
